var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "80%",
      "scrollable": true,
      "name": "calendar-leisure-time",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "calendar-leisure-dialog"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Přehled volna\n    ")]), _vm._v(" "), (_vm.leisureTimePending) ? _c('div', {
    staticClass: "card-body"
  }) : _c('div', {
    staticClass: "card-body"
  }, [(_vm.leisureTime.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "row m-0"
  }, [_c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("datum")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("od - do")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("délka")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-6"
  }, [_vm._v("poznámka")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.leisureTime), function(lt) {
    return [_c('tr', {
      staticClass: "row m-0 text-left",
      attrs: {
        "data-testid": 'calendar-leisure-row-' + lt.id
      }
    }, [(_vm.editingId !== lt.id) ? _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(lt.valid))]) : _vm._e(), _vm._v(" "), (_vm.editingId !== lt.id) ? _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(lt.time_from) + " - " + _vm._s(lt.time_to))]) : _vm._e(), _vm._v(" "), (_vm.editingId !== lt.id) ? _c('td', {
      staticClass: "col-sm-2"
    }, [_vm._v(_vm._s(_vm._f("minutesToCsTime")(lt.duration * 5)))]) : _vm._e(), _vm._v(" "), (_vm.editingId !== lt.id) ? _c('td', {
      staticClass: "col-sm-5"
    }, [_vm._v(_vm._s(lt.note))]) : _c('td', {
      staticClass: "col-sm-11"
    }, [_c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.submitFormUpdateLeisureTime($event)
        }
      }
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("datum")]), _vm._v(" "), _c('datepicker', {
      attrs: {
        "placeholder": "vybrat datum",
        "format": "dd.MM.yyyy",
        "language": "cs",
        "monday-first": true,
        "full-month-name": true,
        "name": "chooseDate",
        "input-class": "datapickerInput"
      },
      model: {
        value: (_vm.formLeisureTime.valid),
        callback: function($$v) {
          _vm.formLeisureTime.valid = $$v
        },
        expression: "formLeisureTime.valid"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("\n                                                      Celý den: \n                                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formLeisureTime.allDay),
        expression: "formLeisureTime.allDay"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.formLeisureTime.allDay) ? _vm._i(_vm.formLeisureTime.allDay, null) > -1 : (_vm.formLeisureTime.allDay)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.formLeisureTime.allDay,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.formLeisureTime.allDay = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.formLeisureTime.allDay = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.formLeisureTime.allDay = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("od")]), _vm._v(" "), _c('timepicker', {
      attrs: {
        "minute-interval": 10,
        "format": "H:mm",
        "disabled": ""
      },
      model: {
        value: (_vm.formLeisureTime.timeFrom),
        callback: function($$v) {
          _vm.formLeisureTime.timeFrom = $$v
        },
        expression: "formLeisureTime.timeFrom"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("do")]), _vm._v(" "), _c('timepicker', {
      attrs: {
        "minute-interval": 10,
        "format": "H:mm",
        "disabled": ""
      },
      model: {
        value: (_vm.formLeisureTime.timeTo),
        callback: function($$v) {
          _vm.formLeisureTime.timeTo = $$v
        },
        expression: "formLeisureTime.timeTo"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v("poznámka")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formLeisureTime.note),
        expression: "formLeisureTime.note"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "leisureTimeNote",
        "placeholder": "poznámka"
      },
      domProps: {
        "value": (_vm.formLeisureTime.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.formLeisureTime.note = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.updatedLeisureTimePending === false && _vm.possibleToSave === true) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Uložit")]) : (_vm.updatedLeisureTimePending === false) ? _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "type": "submit",
        "disabled": "disabled"
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])], 1)])]), _vm._v(" "), _c('td', {
      staticClass: "col-sm-1 text-right"
    }, [(_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "data-testid": 'calendar-leisure-delete-' + lt.id
      },
      on: {
        "click": function($event) {
          _vm.deleteLeisureTime(lt.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-danger disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (_vm.editingId === lt.id) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      on: {
        "click": function($event) {
          _vm.setEditingLeisureTime(lt)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : (_vm.editingId === false) ? _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      attrs: {
        "data-testid": 'calendar-leisure-edit-' + lt.id
      },
      on: {
        "click": function($event) {
          _vm.setEditingLeisureTime(lt)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-secondary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.editingId === false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('form', {
    attrs: {
      "data-testid": "calendar-leisure-add-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitFormAddLeisureTime($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("datum")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datapickerInput"
    },
    model: {
      value: (_vm.formLeisureTime.valid),
      callback: function($$v) {
        _vm.formLeisureTime.valid = $$v
      },
      expression: "formLeisureTime.valid"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                                                      Celý den: \n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formLeisureTime.allDay),
      expression: "formLeisureTime.allDay"
    }],
    attrs: {
      "type": "checkbox",
      "data-testid": "calendar-leisure-all-day"
    },
    domProps: {
      "checked": Array.isArray(_vm.formLeisureTime.allDay) ? _vm._i(_vm.formLeisureTime.allDay, null) > -1 : (_vm.formLeisureTime.allDay)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formLeisureTime.allDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formLeisureTime.allDay = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formLeisureTime.allDay = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formLeisureTime.allDay = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("od")]), _vm._v(" "), _c('timepicker', {
    attrs: {
      "minute-interval": 10,
      "format": "H:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.formLeisureTime.timeFrom),
      callback: function($$v) {
        _vm.formLeisureTime.timeFrom = $$v
      },
      expression: "formLeisureTime.timeFrom"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("do")]), _vm._v(" "), _c('timepicker', {
    attrs: {
      "minute-interval": 10,
      "format": "H:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.formLeisureTime.timeTo),
      callback: function($$v) {
        _vm.formLeisureTime.timeTo = $$v
      },
      expression: "formLeisureTime.timeTo"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("poznámka")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formLeisureTime.note),
      expression: "formLeisureTime.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "leisureTimeNote",
      "placeholder": "poznámka",
      "data-testid": "calendar-leisure-note"
    },
    domProps: {
      "value": (_vm.formLeisureTime.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formLeisureTime.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.newLeisureTimePending === false && _vm.possibleToSave === true) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "data-testid": "calendar-leisure-add"
    }
  }, [_vm._v("Přidat")]) : (_vm.newLeisureTimePending === false) ? _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "type": "submit",
      "disabled": "disabled"
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])], 1)])])]) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c708ed","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Calendar/modals/LeisureTime.vue
// module id = 442
// module chunks = 0